import api from './api';
import { PageType } from '../types';

export interface ReportPublish {
  id: number;
  period: string;
  companyName: string;
  pageType: PageType;
  published: boolean;
  publishedAt: Date | null;
  publishedBy: string | null;
}

export const reportsService = {
  publish: async (
    period: string,
    companyName: string,
    pageType: PageType,
  ): Promise<ReportPublish> => {
    const response = await api.post<ReportPublish>('/reports/publish', {
      period,
      companyName,
      pageType,
    });
    return response.data;
  },

  unpublish: async (
    period: string,
    companyName: string,
    pageType: PageType,
  ): Promise<ReportPublish> => {
    const response = await api.patch<ReportPublish>('/reports/unpublish', {
      period,
      companyName,
      pageType,
    });
    return response.data;
  },
};

